"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_96_103_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
/**
 * recalculate KetteEffektiveLaenge for triflexR
 */
const migration_96_103_0 = (json) => {
    if (!json.Kette)
        return json;
    if (!json.Kette.NumGlieder)
        return json;
    if (!json.Kette.Teilung)
        return json;
    if (json.Kette.KetteSerieType === echain_shared_articles_1.KetteSerieType.triflexR) {
        json.Kette.EffektiveLaengeWithAEs = echain_shared_articles_1.KetteCalculator.calcEffektiveLaenge(json.Kette.NumGlieder, echain_shared_quantities_1.Length.fromJson(json.Kette.Teilung)).toJson();
    }
    return json;
};
exports.migration_96_103_0 = migration_96_103_0;
//# sourceMappingURL=migration_96_103_0.js.map